module.exports = __webpack_public_path__ + "3c555902dd16ed6b0d31aa4fae917029.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/disease_large_blue.png
 ** module id = 1054
 ** module chunks = 0
 **/